export default "__VITE_ASSET__7Gsgb0Ef__"